import { render, staticRenderFns } from "./TopicsForm.vue?vue&type=template&id=bf4608a0&"
import script from "./TopicsForm.vue?vue&type=script&lang=js&"
export * from "./TopicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports